import { forwardRef } from "react";

import { useField, useFormikContext, getIn } from "formik";
import { dissoc } from "ramda";

import {
  MultiEmailInput,
  MultiEmailInputProps,
} from "src/components/MultiEmailInput";

export interface FormikMultiEmailInputProps extends MultiEmailInputProps {
  /** Formik field name. */
  name: string;
}

const FormikMultiEmailInput = forwardRef<
  HTMLInputElement,
  FormikMultiEmailInputProps
>(({ name, onChange: onChangeProp, ...otherProps }, ref) => {
  const [field, meta, { setValue, setTouched }] = useField(name);
  const { status = {}, setStatus } = useFormikContext();
  const fieldStatus = getIn(status, name);

  return (
    <MultiEmailInput
      ref={ref}
      error={meta.touched ? meta.error || fieldStatus : ""}
      value={field.value}
      onBlur={() => setTouched(true)}
      onChange={value => {
        setStatus(dissoc(name, status));
        setValue(value);
        onChangeProp?.(value);
      }}
      {...otherProps}
    />
  );
});

FormikMultiEmailInput.displayName = "FormikMultiEmailInput";

export { FormikMultiEmailInput };
